<booking-payment-mobile *ngIf="isMobile"></booking-payment-mobile>
<booking-payment-desktop *ngIf="!isMobile"></booking-payment-desktop>